// extracted by mini-css-extract-plugin
export default {"site_info":"SiteInfo_site_info__PuGoY","site_info__name":"SiteInfo_site_info__name__dCtGa","site_info__tz":"SiteInfo_site_info__tz__RP+GF"};